// Brick atamaları ay sınırlarına göre çalışır: bir atama ayın son günü kapanır,
// yerine gelen atama ertesi ayın 1'inde başlar.
// monthValue: <input type="month"> değeri, 'YYYY-MM'
// Dönüş: { endDate: 'YYYY-MM-DD' (ayın son günü), nextStart: 'YYYY-MM-DD' (ertesi ayın 1'i) }
// Geçersiz/boş değer için { endDate: '', nextStart: '' } döner.
export const monthBounds = (monthValue) => {
  const match = /^(\d{4})-(\d{2})$/.exec(monthValue || '');
  if (!match) return { endDate: '', nextStart: '' };

  const year = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) return { endDate: '', nextStart: '' };

  const pad = (n) => String(n).padStart(2, '0');
  const lastDay = new Date(year, month, 0).getDate();
  const nextMonth = month === 12 ? 1 : month + 1;
  const nextYear = month === 12 ? year + 1 : year;

  return {
    endDate: `${year}-${pad(month)}-${pad(lastDay)}`,
    nextStart: `${nextYear}-${pad(nextMonth)}-01`,
  };
};

// 'YYYY-MM-DD' → '01.09.2026' (yerel gösterim; saat dilimi kaymasına karşı T00:00:00 eklenir)
export const formatDate = (isoDate) =>
  isoDate ? new Date(`${isoDate}T00:00:00`).toLocaleDateString('tr-TR') : '';
